<div *ngIf="allPhases" class="venture-phase">
  <ng-container
    *ngFor="let item of allPhases; first as istFirst; index as index"
  >
    <div
      #phaseBar
      *ngIf="!istFirst"
      class="venture-phase__bar"
      [class]="{
        active: index <= currentIndex,
        current: index == currentIndex
      }"
      [class.bg-primary]="index <= currentIndex"
    ></div>
    <div
      #phaseCircle
      (click)="select(item, index)"
      class="venture-phase__circle"
      [class.pointer-cursor]="editable"
      [class]="{
        active: index <= currentIndex,
        'bg-primary': index < currentIndex,
        current: index == currentIndex,
      }"
      [ngbTooltip]="tooltipContent"
    >
      @if(uiTemplateName === templateName.Reduced4) {
      <span
        class="phase-text text-center"
        [class]="{
          active: index <= currentIndex,
          'text-primary': index === currentIndex,
          current: index == currentIndex
        }"
      >
        <p>{{ index }}</p>
        <p>{{ item.value }}</p>
      </span>
      } @else {
      <span
        class="phase-text text-center"
        [class]="{
          active: index <= currentIndex,
          'text-primary': index === currentIndex,
          current: index == currentIndex
        }"
        >{{ item.value }}</span
      >
      }
      <i class="fas fa-check"></i>
      <i
        class="fas fa-circle"
        [class]="{ 'text-primary': index === currentIndex }"
      ></i>

      <ng-template #tooltipContent>
        @if(uiTemplateName === templateName.Reduced4) {
          <div class="text-center">
            <p>{{ index }}</p>
            <p>{{ item.value }}</p>
          </div>
        } @else {
          <span>{{item?.value}}</span>
        }
      </ng-template>
    </div>
  </ng-container>
</div>
